module.exports = require('react/lib/shallowCompare');


//////////////////
// WEBPACK FOOTER
// ./~/react-addons-shallow-compare/index.js
// module id = 273
// module chunks = 1